export default __webpack_public_path__ + "static/media/icn_escrow3.0e2f1710.svg";